// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-258e9ee4] .intl-phone-input{width:100%}[data-v-258e9ee4] .intl-phone-input .country-list{max-height:100px}.warning-text[data-v-258e9ee4]{text-align:center;color:red;font-size:14px;margin:8px}", ""]);
// Exports
module.exports = exports;
